import React, { useEffect, useState, useContext } from "react";
import Typography from "@mui/material/Typography";
import LongTextComponent from "../Leads Page/LongTextComponent";
import {
  GridToolbar,
  GridToolbarColumnsButton,
  GridToolbarFilterButton,
  GridToolbarQuickFilter,
} from "@mui/x-data-grid";
import { DataGrid } from "@mui/x-data-grid";
import {
  useMediaQuery,
  useTheme,
  Chip,
  IconButton,
  Tooltip,
  Button,
  Menu,
  MenuItem,
  Box,
  TablePagination,
  Paper,
  TableContainer,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Table,
  TextField,
} from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import DangerousIcon from "@mui/icons-material/Dangerous";
import { useNavigate } from "react-router-dom";
import { LoginContext } from "../LoginPage/LoginContext";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import SaveAltIcon from "@mui/icons-material/SaveAlt";
import { GridToolbarContainer } from "@mui/x-data-grid";
import DownloadIcon from "@mui/icons-material/Download";
import axios from "axios";
import { HO_DOCUMENT_DOWNLOAD } from "../../constants";
import VisibilityIcon from "@mui/icons-material/Visibility";
import FileDownloadIcon from "@mui/icons-material/FileDownload";


function AllEstimationRequestsListComponent({
  finalEstimationRow,
  setLoading,
}) {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  const navigate = useNavigate();

  const [page, setPage] = useState(0); // Current page
    const [rowsPerPage, setRowsPerPage] = useState(10); // Rows per page
    const [searchTerm, setSearchTerm] = useState("");

  const handleSearchChange = (event) => {
    setSearchTerm(event.target.value.toLowerCase());
    setPage(0); // Reset page to 0 after search
  };
  
    const handleChangePage = (event, newPage) => {
      setPage(newPage);
    };
  
    const handleChangeRowsPerPage = (event) => {
      setRowsPerPage(parseInt(event.target.value, 10));
      setPage(0); // Reset to first page when rows per page changes
    };

  const IconCell = ({ row }) => (
    <div className="flex">
      {/* Edit button */}
      {row.status !== "converted" && (
        <Tooltip title="Edit" arrow>
          <IconButton
            style={{
              border: "1px solid",
              borderRadius: "4px",
              padding: "2px",
              width: "24px",
              height: "24px",
              justifyContent: "center",
              alignItems: "center",
              backgroundColor: '#fff'
            }}
            color="primary"
            disabled={
              row.status === "Generated" ||
              row.status === "Estimation Shared" ||
              row.status === "rejected"
            }
            onClick={() => handleIconClick(row)}
          >
            <EditIcon
              fontSize="small"
              color={
                row.status === "Generated" ||
                row.status === "Estimation Shared" ||
                row.status === "rejected"
                  ? "disabled"
                  : "primary"
              }
            />
          </IconButton>
        </Tooltip>
      )}

      {/* Reject button */}
      {row.status !== "converted" && (
        <Tooltip title="Reject" arrow>
          <IconButton
            style={{
              border: "1px solid",
              borderRadius: "4px",
              padding: "2px",
              width: "24px",
              height: "24px",
              justifyContent: "center",
              alignItems: "center",
              marginLeft: "4px",
              backgroundColor: '#fff'
            }}
            color="error"
            disabled={
              row.status === "Generated" ||
              row.status === "Estimation Shared" ||
              row.status === "rejected"
            }
            onClick={() => handleRejectIconClick(row)}
          >
            <DangerousIcon
              fontSize="small"
              color={
                row.status === "Generated" ||
                row.status === "Estimation Shared" ||
                row.status === "rejected"
                  ? "disabled"
                  : "error"
              }
            />
          </IconButton>
        </Tooltip>
      )}

      {/* Download button */}
      {(row.status === "Generated" || row.status === "Estimation Shared") &&
        row.ho_document &&
        row.ho_document.length > 0 && (
          <Tooltip title="Download" arrow>
            <IconButton
              style={{
                border: "1px solid",
                borderRadius: "4px",
                padding: "2px",
                width: "24px",
                height: "24px",
                justifyContent: "center",
                alignItems: "center",
                marginLeft: "4px",
                backgroundColor: '#fff'
              }}
              color="success"
              onClick={() => handleDownload(row)} // Pass the document URL
            >
              <DownloadIcon fontSize="small" />
            </IconButton>
          </Tooltip>
        )}

      {row.status === "converted" && (
        <Tooltip title="View" arrow>
          <IconButton
            style={{
              border: "1px solid",
              borderRadius: "4px",
              padding: "2px",
              width: "24px",
              height: "24px",
              backgroundColor: "#fff",
              justifyContent: "center",
              alignItems: "center",

            }}
            color="primary"
            onClick={() => handleOnConvertedViewClick(row)}
          >
            <VisibilityIcon fontSize="small" color="primary" />
          </IconButton>
        </Tooltip>
      )}
    </div>
  );

  const handleOnConvertedViewClick = (row) => {
    navigate("/bdmDetails/converted/view", {
      state: { MobNo: row.MobNo, leadId: row.LeadDetailId },
    });
  };

  // Function to handle the download
  const handleDownload = (row) => {
    setLoading(true);

    axios({
      method: "get",
      url: `${HO_DOCUMENT_DOWNLOAD}/${row.estimationId}`,
      responseType: "blob",
      headers: {
        Authorization: `Bearer ${localStorage.getItem("authToken")}`,
        "Content-Type": "application/json",
      },
    })
      .then((response) => {
        setLoading(false);

        const blob = new Blob([response.data], { type: "application/zip" });
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;

        const filename = `Documents_${row.estimationId}_${
          new Date().toISOString().split("T")[0]
        }.zip`;
        link.setAttribute("download", filename);

        document.body.appendChild(link);
        link.click();
        link.remove();
        window.URL.revokeObjectURL(url);

        // Optional: Show success message
        // enqueueSnackbar('Document downloaded successfully', { variant: 'success' });
      })
      .catch((error) => {
        setLoading(false);

        // Detailed error logging and user feedback
        console.error("Download error:", error);

        let errorMessage = "Failed to download document";

        if (error.response) {
          // Check if error response is a Blob
          if (error.response.data instanceof Blob) {
            // Convert Blob to text (without await)
            error.response.data
              .text()
              .then((text) => {
                errorMessage = text;
                // enqueueSnackbar(errorMessage, { variant: 'error' });
                console.log(errorMessage);
              })
              .catch(() => {
                // enqueueSnackbar(errorMessage, { variant: 'error' });
                console.log(errorMessage);
              });
          } else {
            // Use existing error response or default message
            errorMessage = error.response.data || "Server error occurred";
            console.log(errorMessage);
            // enqueueSnackbar(errorMessage, { variant: 'error' });
          }
        } else if (error.request) {
          // The request was made but no response was received
          // enqueueSnackbar('No response received from server', { variant: 'error' });
          console.log("No response received from server");
        } else {
          // Something happened in setting up the request that triggered an Error
          // enqueueSnackbar('Error in download process', { variant: 'error' });
          console.log("Error in download process");
        }
      });
  };

  const handleIconClick = (row) => {
    localStorage.setItem("leadDetails", JSON.stringify(row));
    navigate("/estimateDetails");
  };

  const handleRejectIconClick = (row) => {
    localStorage.setItem("leadDetails", JSON.stringify(row));
    navigate("/estimateDetails", {
      state: { defaultStatus: "Rejected with Remarks" },
    });
  };

  const columnsPending = [
    { field: "sno", headerName: "SNo", width: isMobile ? 30 : 50 },
    {
      field: "EstimationRequirement",
      headerName: "Estimation Requirement",
      width: isMobile ? 180 : 180,
      renderCell: (value) =>
        value === "-" ? (
          <Typography>-</Typography>
        ) : (
          <Typography
            sx={{
              textTransform: "capitalize",
              height: "20px",
              fontWeight: "700",
              fontSize: "0.8rem",
            }}
          >
            {value}
          </Typography>
        ),
    },
    {
      field: "status",
      headerName: "Status",
      width: isMobile ? 180 : 150,
      renderCell: (value) =>
        value === "-" ? (
          <Typography>-</Typography>
        ) : (
          <Chip
            size="small"
            label={value}
            color={getColorForTag(value)}
            sx={{ textTransform: "capitalize", height: "20px", margin: "10px" }}
          />
        ),
    },
    {
      field: "last_estimation_number",
      headerName: "Last Estimation Number",
      width: isMobile ? 180 : 200,
    },
    {
      field: "estimationNumber",
      headerName: "Estimation Number",
      width: isMobile ? 180 : 150,
    },
    {
      field: "estimation_amount",
      headerName: "Estimation Value",
      width: isMobile ? 180 : 150,
    },
    {
      field: "firm_farmer_name",
      headerName: "Firm/Farmer Name",
      width: isMobile ? 180 : 150,
    },
    {
      field: "Estimation_generated_date",
      headerName: "Estimation Generated Date & Time",
      width: isMobile ? 180 : 200,
    },
    {
      field: "Estimation_request_date",
      headerName: "Estimation Request Date & Time",
      width: isMobile ? 180 : 200,
    },
    {
      field: "BdmName",
      headerName: "Requested By",
      width: isMobile ? 180 : 150,
    },
    {
      field: "farmerName",
      headerName: "Farmer Name",
      width: isMobile ? 180 : 150,
    },
    {
      field: "MobNo",
      headerName: "Mobile Number",
      width: isMobile ? 180 : 150,
    },
    { field: "Project", headerName: "Project", width: isMobile ? 180 : 150 },
    {
      field: "StateName",
      headerName: "State Name",
      width: isMobile ? 180 : 150,
    },
    {
      field: "RegionName",
      headerName: "Region Name",
      width: isMobile ? 180 : 150,
    },
    {
      field: "CivilConstructedStarted",
      headerName: "Civil Construction Started",
      width: isMobile ? 180 : 150,
    },
    {
      field: "ShedLength",
      headerName: "Shed Length",
      width: isMobile ? 180 : 150,
    },
    {
      field: "EquipementPlacementLength",
      headerName: "Equipment Placement Length",
      width: isMobile ? 180 : 150,
    },
    {
      field: "ShedWidth",
      headerName: "Shed Width",
      width: isMobile ? 180 : 150,
    },
    { field: "CShape", headerName: "C-Shape", width: isMobile ? 180 : 150 },
    {
      field: "ModalType",
      headerName: "Model Type",
      width: isMobile ? 180 : 150,
    },
    {
      field: "SideWallColumnToColumnGap",
      headerName: "Side Wall Column to Column Gap",
      width: isMobile ? 180 : 250,
    },
    {
      field: "NumberOfSheds",
      headerName: "Number of Sheds",
      width: isMobile ? 180 : 150,
    },
    {
      field: "CurtainRequirment",
      headerName: "Curtain Requirement",
      width: isMobile ? 180 : 150,
    },
    {
      field: "DiselBrooderRequirment",
      headerName: "Diesel Brooder Requirement",
      width: isMobile ? 180 : 150,
    },
    {
      field: "PowerSupply",
      headerName: "Power Supply",
      width: isMobile ? 180 : 150,
    },
    {
      field: "WaterSupply",
      headerName: "Water Available",
      width: isMobile ? 180 : 150,
    },
    {
      field: "Remarks",
      headerName: "Remarks",
      width: isMobile ? 180 : 300,
      renderCell: (value) => (
        <LongTextComponent text={value || ""} maxLength={50} />
      ),
    },
    {
      field: "action",
      headerName: "Action",
      width: 100,
      renderCell: (value, row) => <IconCell row={row} />,
    },
  ];

  const getColorForTag = (tag) => {
    switch (tag.toLowerCase()) {
      case "pending":
        return "error";
      case "need for approval":
        return "warning";
      case "generated":
        return "success";
      case "converted":
        return "success";
      case "rejected":
        return "error";
      case "estimation shared":
        return "secondary";
      default:
        return "default";
    }
  };

  // Filter rows based on the search term
  const filteredRows = finalEstimationRow.filter((row) =>
    Object.values(row).some(
      (value) =>
        value &&
        value.toString().toLowerCase().includes(searchTerm) // Case-insensitive match
    )
  );


  // Slice the rows to match pagination
  const rowsToDisplay = filteredRows.slice(
    page * rowsPerPage,
    page * rowsPerPage + rowsPerPage
  );  

  const exportToExcel = () => {
    // Create a new worksheet
    const worksheetData = finalEstimationRow.map((row) => {
      const rowData = {};
      columnsPending.forEach((column) => {
        // Map each column field to the corresponding row data
        rowData[column.headerName] = row[column.field] || "";
      });
      return rowData;
    });

    // Create a worksheet and workbook
    const worksheet = XLSX.utils.json_to_sheet(worksheetData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Estimation Data");

    // Write the file
    XLSX.writeFile(workbook, "estimation_data.xlsx");
  };

  return (
    <>
      <Paper>

      <IconButton
          onClick={() => exportToExcel()}
          style={{
            border: "1px solid #fff", // Change border color to white for contrast
            borderRadius: "4px",
            // margin: "5px",
            width: "40px", // Increased width for a more comfortable click area
            height: "40px", // Increased height for a more comfortable click area
            justifyContent: "center",
            alignItems: "center",
            backgroundColor: "#097969",
            color: "#fff",
            transition: "background-color 0.3s, transform 0.2s", // Smooth transition effects
            boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.2)", // Add shadow for depth
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.backgroundColor = "#0B9B73"; // Darker shade on hover
            e.currentTarget.style.transform = "scale(1.05)"; // Slightly scale up on hover
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.backgroundColor = "#097969"; // Original color
            e.currentTarget.style.transform = "scale(1)"; // Reset scale
          }}
        >
          <FileDownloadIcon /> {/* Change icon based on state */}
        </IconButton>

      {/* Search Field */}
      <TextField
        variant="outlined"
        size="small"
        placeholder="Search..."
        sx={{ margin: 1, float: "right" }}
        onChange={handleSearchChange}
      />

      <TableContainer
        sx={{
          boxShadow: 2,
          borderRadius: "8px",
        }}
      >
        <Table
          sx={{ minWidth: 650, tableLayout: "fixed" }}
          aria-label="simple table"
          stickyHeader
        >
          <TableHead>
            <TableRow>
              {columnsPending.map((column) => (
                <TableCell
                  key={column.field}
                  align="center"
                  sx={{
                    backgroundColor: "#EEF0F4",
                    fontSize: "0.8rem",
                    fontWeight: "bold",
                    ...(column.field === "action" && {
                      position: "sticky",
                      right: 0,
                      zIndex: 2,
                      backgroundColor: "#EEF0F4",
                      boxShadow: "0 2px 5px rgba(0,0,0,0.1)",
                    }),
                  }}
                  width={column.width}
                >
                  {column.headerName}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {rowsToDisplay.map((row, rowIndex) => (
              <TableRow key={rowIndex}>
                {columnsPending.map((column) => {
                  const cellValue = row[column.field];
                  return (
                    <TableCell
                      key={column.field}
                      align="center"
                      sx={{
                        ...(column.field === "action" && {
                          position: "sticky",
                          right: 0,
                          zIndex: 1,
                          backgroundColor: "#EEF0F4", // Matches table body background
                        }),
                      }}
                    >
                      {column.field === "Remarks" ? (
                        <LongTextComponent
                          text={cellValue || ""}
                          maxLength={50}
                        />
                      ) : column.field === "action" ? (
                        <IconCell row={row} />
                      ) : column.field === "status" ? (
                        <Chip
                          size="small"
                          label={cellValue}
                          color={getColorForTag(cellValue)}
                          sx={{
                            textTransform: "capitalize",
                            height: "20px",
                            margin: "10px",
                          }}
                        />
                      ) : (
                        <Typography
                          sx={{
                            textTransform: "capitalize",
                            fontSize: "0.8rem",
                          }}
                        >
                          {cellValue}
                        </Typography>
                      )}
                    </TableCell>
                  );
                })}
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>

      <TablePagination
        rowsPerPageOptions={[5, 10, 25]}
        component="div"
        count={filteredRows.length}
        rowsPerPage={rowsPerPage}
        page={page}
        onPageChange={handleChangePage}
        onRowsPerPageChange={handleChangeRowsPerPage}
      />
    </Paper>
    </>
  );
}

export default AllEstimationRequestsListComponent;
